import React from 'react';
import { FeedbackChat } from './FeedbackChat';
import { useFeedbackChat } from './useFeedbackChat';

interface Props {
  appCode: string;
}

export const FeedbackChatPage: React.FC<Props> = ({ appCode }) => {
  const params =
    typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : new URLSearchParams();
  const returnUrl = params.get('returnUrl') || '/';
  const pageKey = params.get('pageKey') || '/';
  const openerTitle = params.get('pageTitle') || '';

  const chat = useFeedbackChat({ appCode, pageKey });

  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <div
        style={{
          padding: 8,
          borderBottom: '1px solid #eee',
          display: 'flex',
          gap: 8,
          alignItems: 'center',
        }}
      >
        <a href={returnUrl} style={{ fontSize: 12, color: '#20314D' }}>
          ← 돌아가기
        </a>
        <span style={{ fontSize: 12, color: '#666' }}>{openerTitle || pageKey}</span>
      </div>
      <div style={{ flex: 1, minHeight: 0 }}>
        <FeedbackChat
          chat={chat}
          appCode={appCode}
          onSubmitted={() => {
            alert('제출됨');
          }}
        />
      </div>
    </div>
  );
};
